import { UPDATE_LOCATION } from '../reducers/constants/currentLocation';

export const updateLocation = (lat, long) => ({
  type: UPDATE_LOCATION,
  lat,
  long
});
